import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from './views/Dashboard'
import SelectProject from './views/SelectProject'
import HelloWorld from './views/HelloWorld'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      name: 'dashboard',
      path: '/',
      component: Dashboard,
    },
    {
      name: 'select-project',
      path: '/select-project',
      component: SelectProject,
    },
    {
      name: 'hello',
      path: '/set-token',
      component: HelloWorld,
    },
  ],
})
